<template>
    <div class="card" id="voice">
      <nav class="fixed-bar navbar navbar-expand-lg navbar-light" color="white">
        <h3 class="navbar-brand">Voice</h3>
        <add-voice
          @save="saveSetDesign"
          @open="openDialog"
          @close="closeDialog"
          v-bind:dialog="dialog"
          v-bind:info="editedItem"
          v-bind:edited-i-d="editedID"
          v-bind:showSaveButton="showSaveButton">
        </add-voice>
      </nav>
      <hr/>
      <div class="container fluid grid-list-lg">
        <asset-table
          v-bind:updated="updated"
          v-bind:asset_type="asset_type"
          @edit="editItem"
          v-bind:headers="headers"></asset-table>
      </div>
    </div>
</template>

<script>
  import {db, assetAudioStorageRef} from '../../firebaseDB'
  import AssetTable from './assetTable'
  import AddVoice from './add-new/addVoice'

  export default {
    name: 'voice',
    components: {AddVoice, AssetTable},
    data: () => ({
      asset_type: 'voice',
      headers: [
        {th: 'Name', name: 'name'},
        {th: 'Date Uploaded', name: 'date_uploaded'},
        // {th: 'Date Modified', name: 'date_modified'},
        {th: 'Uploaded By', name: 'creator'},
        // {th: 'Description', name: 'description'},
        // {th: 'Service', name: 'service'},
        {th: 'Media',
          name: 'media',
          render (row, cell, index) {
            if (row.hasOwnProperty('image')) {
              return `<a href="${row.image.imageURL}" target="_blank">
                  <img src="${row.image.imageURL}" style="width: 50px; height: 50px">
                </a>`
            } else if (row.hasOwnProperty('audio')) {
              return `<button type="button" class="btn btn-default"></button>`
            } else {
              return ''
            }
          }
        }
      ],
      dialog: '',
      updated: false,
      showSaveButton: true,
      editedItem: {
        id: null,
        name: '',
        filename: '',
        audio: {
          audioName: '',
          audioURL: '',
          audioFile: ''
        },
        service: '',
        description: ''
      },
      defaultItem: {
        id: null,
        name: '',
        filename: '',
        audio: {
          audioName: '',
          audioURL: '',
          audioFile: ''
        },
        service: '',
        description: ''
      },
      editedID: -1,
      editedIndex: -1,
      tableData: []
    }),
    methods: {
      saveSetDesign (updatedData) {
        const currentdate = new Date()
        const datetime = currentdate.getDate() + '/' +
          (currentdate.getMonth() + 1) + '/' +
          currentdate.getFullYear() + ' @ ' +
          currentdate.getHours() + ':' +
          currentdate.getMinutes() + ':' +
          currentdate.getSeconds()
        setTimeout(() => {
          let updates = {}
          if (!updatedData.id) {
            updatedData.id = db.ref(`asset_data/${this.asset_type}/`).push().key
            updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/creator`] = this.$store.state.user.email
            updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/date_uploaded`] = datetime
          }
          updates[`asset_data/${this.asset_type}/${updatedData.id}/description`] = updatedData.description || ''
          updates[`asset_data/${this.asset_type}/${updatedData.id}/service`] = updatedData.service || ''
          updates[`asset_data/${this.asset_type}/${updatedData.id}/name`] = updatedData.name || ''
          updates[`asset_data/${this.asset_type}/${updatedData.id}/meta_data/date_modified`] = datetime
          if (updatedData.audio && updatedData.audio.audioFile) {
            assetAudioStorageRef.child(`${updatedData.id}.mp3`)
              .put(updatedData.audio.audioFile)
              .then(snapshot => snapshot.ref.getDownloadURL())
              .catch(function (error) {
                console.log('Error - ' + error.message)
              })
              .then((URL) => {
                updatedData.audio.audioURL = URL
              })
              .then(snapshot => {
                updates[`asset_data/${this.asset_type}/${updatedData.id}/audio`] = updatedData.audio || {
                  audioURL: '',
                  audioFile: ''
                }
                db.ref('assets').update(updates)
                  .then(snapshot => {
                    this.closeDialog()
                    this.updated = true
                  })
              })
          } else {
            db.ref('assets').update(updates).then(snapshot => {
              this.closeDialog()
              this.updated = true
            })
          }
        }, 500)
        this.updated = false
      },
      openDialog () {
        this.dialog = true
      },
      closeDialog () {
        this.editedID = -1
        this.editedIndex = -1
        this.editedItem = Object.assign({}, this.defaultItem)
        this.dialog = false
      },
      editItem (item) {
        this.editedIndex = item.index
        this.editedID = item.id
        this.editedItem = Object.assign(this.getEditedItem(item.item), item.item)
        this.showSaveButton = item.showSaveButton
        this.dialog = true
      },
      getEditedItem (item) {
        let audio = {
          audioName: '',
          audioURL: '',
          audioFile: ''
        }
        db.ref(`assets/asset_data/${this.asset_type}/${item.id}/audio`)
          .once('value')
          .then((snapshot) => {
            if (snapshot.val() !== null) {
              audio = snapshot.val()
            }
          })
          .catch(function (error) {
            console.log('Error - ' + error.message)
          })
        return { audio }
      }
    }
  }
</script>

<style scoped>
#voice{
  scroll-margin: 150px;
}
</style>




// WEBPACK FOOTER //
// src/components/assets/voice.vue